export default __webpack_public_path__ + "static/wojciechh-65db0286976e82c0646847d22c2c47b1.jpg";